const KNOWN_CITY_COORDS = {
  positano: { lat: 40.6287, lng: 14.484 },
  capri: { lat: 40.5507, lng: 14.2426 },
  anacapri: { lat: 40.5536, lng: 14.2167 },
  ravello: { lat: 40.6493, lng: 14.6118 },
  amalfi: { lat: 40.634, lng: 14.6027 },
  sorrento: { lat: 40.6263, lng: 14.3758 },
  'conca dei marini': { lat: 40.6178, lng: 14.5731 },
  'massa lubrense': { lat: 40.6097, lng: 14.3447 },
  nerano: { lat: 40.5832, lng: 14.3508 },
  praiano: { lat: 40.6119, lng: 14.5336 },
  maiori: { lat: 40.6486, lng: 14.6408 },
  minori: { lat: 40.6503, lng: 14.6267 },
  'vietri sul mare': { lat: 40.67, lng: 14.7278 },
  naples: { lat: 40.8518, lng: 14.2681 },
  napoli: { lat: 40.8518, lng: 14.2681 },
  rome: { lat: 41.9028, lng: 12.4964 },
  roma: { lat: 41.9028, lng: 12.4964 },
  florence: { lat: 43.7696, lng: 11.2558 },
  firenze: { lat: 43.7696, lng: 11.2558 },
  paris: { lat: 48.8566, lng: 2.3522 },
  london: { lat: 51.5074, lng: -0.1278 },
  dubai: { lat: 25.2048, lng: 55.2708 }
};

function normalizeQuery(query) {
  return String(query || '')
    .toLowerCase()
    .replace(/\b\d{4,}\b/g, '')
    .replace(/\b(sa|na|italy|italia)\b/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Split "Las Vegas, NV" or "Dubai - United Arab Emirates" into searchable parts. */
export function locationSearchTokens(query) {
  const raw = String(query || '').trim();
  if (!raw) return [];
  const parts = raw
    .split(/\s*[-–,|/]\s*|\s*,\s*/)
    .map((part) => part.trim())
    .filter((part) => part && part.length > 1);
  return [...new Set([parts[0], raw, ...parts].filter(Boolean))];
}

export function primaryCityName(query) {
  return locationSearchTokens(query)[0] || String(query || '').trim();
}

export function knownCityCoords(query) {
  const text = normalizeQuery(query);
  if (!text) return null;
  if (KNOWN_CITY_COORDS[text]) return KNOWN_CITY_COORDS[text];

  const parts = locationSearchTokens(text)
    .map((part) => part.toLowerCase())
    .filter(Boolean);
  for (const part of parts) {
    if (KNOWN_CITY_COORDS[part]) return KNOWN_CITY_COORDS[part];
  }

  const keys = Object.keys(KNOWN_CITY_COORDS).sort((a, b) => b.length - a.length);
  for (const key of keys) {
    if (new RegExp(`(?:^|[^a-z])${key}(?:$|[^a-z])`).test(text)) {
      return KNOWN_CITY_COORDS[key];
    }
  }
  return null;
}
